import { NgModule } from "@angular/core";
import { MenuWorkflowComponent } from "./menu-workflow.component";
import { MenuWorkflowContentComponent } from "./menu-workflow-content.component";
import { WorkflowService } from "../workflow.service";
import { MenuWorkflowService } from "./menu-workflow.service";
import { CommonModule } from "@angular/common";
import { CreatePageService } from "../../cms/content/create-page/create-page.service";
import { ContentService } from "../../cms/content/content.service";
import { TranslateModule } from "@ngx-translate/core";
import { NgScrollbarModule } from "ngx-scrollbar";

@NgModule({
    declarations: [
        MenuWorkflowComponent
    ], exports: [
        MenuWorkflowComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        NgScrollbarModule,
        MenuWorkflowContentComponent
    ],
    providers: [
        MenuWorkflowService,
        CreatePageService,
        WorkflowService
    ]
})

export class MenuWorkflowModule{}
